// components/ComboDisplay/Events/StackTimeoutGroup.tsx

import React from 'react';
import { GameLog } from '../../../../../Logs/LogsDisplay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassEnd } from '@fortawesome/free-solid-svg-icons';
import './StackTimeoutGroup.css';
import StackEvent from './StackEvent';

interface StackTimeoutGroupProps {
  logs: GameLog[];
}

const StackTimeoutGroup: React.FC<StackTimeoutGroupProps> = ({ logs }) => {
  return (
    <div className="stack-timeout-group-container">
      <div className="stack-timeout-group-icon">
        <FontAwesomeIcon icon={faHourglassEnd} className="hourglass-icon" />
      </div>
      <div className="stack-timeout-group-details">
        {logs.map((log) => (
          <StackEvent key={log.id} log={log} isGreyscale={true} />
        ))}
      </div>
    </div>
  );
};

export default StackTimeoutGroup;
